import React from 'react';
import SignUpQuery from "./SignUpQuery";
import {setLogin } from "../../Features/Misc/loginSlice";
import {useDispatch, useSelector} from "react-redux";

export default function LoginQuery() {

    //redux methods
    const dispatch = useDispatch();

    //redux state
    const { actionType } = useSelector((state) => state.login)

    return (
        <>

            {actionType === "Sign Up" &&

        <div className={"flex flex-row text-lg text-white items-center text-center justify-center gap-2"}>
            <div>Already have an Account?</div>
            <div onClick={() => dispatch(setLogin())} className={"text-white font-semibold underline cursor-pointer"}>Log In
            </div>
        </div>

            }

            {actionType === "Log In" &&
                <SignUpQuery />



            }


        </>

    );
}
